import { Button, Card, Flex, Tooltip } from 'antd';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
/* import all the icons in Free Solid, Free Regular, and Brands styles */
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { Link, useNavigate } from 'react-router-dom';
import ManageLocalStorage from 'utils/local-storage';
import { useTranslation } from 'react-i18next';
import useDashboardTheme from 'components/shared-components/Dashboard/useDashboardTheme';
import {
    getModuleCardOpenButtonPresentation,
    getModuleCardShellStyle,
} from 'components/shared-components/Dashboard/dashboardThemeTokens';

library.add(fas, far, fab);
const ModuleCard = (props) => {
    const {
        key,
        module,
        disabled = true
    } = props;

    const { 
        feature = [],
        statistic = [],
        // color = '#10b98199' 
    } = module;


    const navigate = useNavigate();
    const dashboardTheme = useDashboardTheme();
    const accentColor = dashboardTheme.accentPrimary;
    const statisticLabelColor = dashboardTheme.textMuted;
    const statisticValueColor = dashboardTheme.statValueColor ?? accentColor;
    const { t } = useTranslation(['home']);

    const openModuleEnabled = !disabled && module?.status === 'available';
    const openModuleButtonPresentation = openModuleEnabled
        ? getModuleCardOpenButtonPresentation(dashboardTheme)
        : { className: 'module-card-open-module-btn', style: undefined };

    return (
        <Card
            key={key}
            className="ant-main-card dashboard-module-card h-100"
            style={getModuleCardShellStyle(dashboardTheme)}
        >
            <div className="flex flex-col h-100">
                <div className="flex items-start justify-between mb-2 w-100">
                    <div className="flex align-center gap-3 flex-1 min-w-0 w-100">
                        <Button type="primary" size='large' shape="circle" icon={<FontAwesomeIcon icon={module.icon ?? 'fa-regular fa-circle'} />} />
                        <div className="flex flex-column align-start flex-1 pl-2" style={{width: `calc(100% - 50px)`}}>
                            <div className="font-size-md font-semibold text-foreground leading-snug overflow-hidden" style={{
                                display: 'inline-block',
                                width: '100%',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                fontWeight: 'bold'
                            }}>
                                {/* <b className="font-size-md font-semibold text-foreground leading-snug"> */}
                                <Tooltip title={t(`apps.${module.code}`, module.name)}>
                                    {t(`apps.${module.code}`, module.name)}
                                </Tooltip>
                                {/* </b> */}
                            </div>
                            <div className='px-2' style={{ border: `solid 1px ${accentColor}`, display: 'inline-block', borderRadius: 16 }}>
                                <span style={{ color: accentColor }}>{t(`apps.categories.${module.category}`, module.category)}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="font-size-sm text-muted-foreground leading-relaxed mb-3 line-clamp-2 overflow-hidden" style={{textAlign: 'justify', height: 80, justifyContent: 'center'}}>
                    {t(`apps.description.${module.code}`, module.description)}
                </div>
                <div className="flex flex-column justify-content-start align-start w-100 statistic" style={{gap: 4}}>
                    {
                        statistic.map(e => (
                            <div key={e.key} className="flex w-100 flex-row align-center justify-content-between gap-2 pt-1 statistic-item">
                                <span className="font-size-sm truncate" style={{ color: statisticLabelColor }}>
                                    <FontAwesomeIcon
                                        className="mr-1"
                                        icon={module.icon ?? 'fa-regular fa-circle'}
                                        color={accentColor}
                                    />
                                    <span>{t(`apps.statistic.${e.code}`, e.name)}</span>
                                </span>
                                <div className="flex align-center gap-2 flex-shrink-0">
                                    {
                                        ManageLocalStorage.check_role(e.key) ? 
                                        <>
                                            <span className="font-size-sm font-mono font-medium text-foreground" style={{ color: statisticValueColor }}>{e.value}</span>
                                            <span className="font-size-sm text-muted-foreground truncate">{e.unit}</span>
                                        </> : <FontAwesomeIcon size='sm' icon={'fa-solid fa-lock'} className='text-muted-foreground' />
                                    }
                                    
                                </div>
                            </div>
                        )
                    )}
                </div>
                <div className="w-100 flex flex-column align-start justify-content-start flex-1 pt-3" style={{ gap: 8 }}>
                    {
                        feature.map(e => (
                            ManageLocalStorage.check_role(e.key) ?
                                <Button
                                    key={e.key}
                                    size="small"
                                    type='default'
                                    block
                                    onClick={() => {
                                        navigate(e.path)
                                    }}
                                >
                                    <Flex justify='space-between' align='center'>
                                        <span className="font-size-sm transition-colors">{t(`apps.module.${e.code}`, e.name)}</span>
                                        <FontAwesomeIcon size="xs" style={{ color: accentColor }} icon={'fa-solid fa-angle-right'} />
                                    </Flex>
                                </Button>
                            : <></>
                        )
                    )}
                </div>
                <Flex className='w-100' justify='space-between' align='flex-end'>
                    <div className='flex-1'>
                        {/* <Button 
                            icon={<FontAwesomeIcon size='xs' style={{color: color}} icon={'fa-solid fa-book-open'} />}
                            type={'default'}
                            size="small"
                        /> */}
                    </div>
                    <Button
                        type="default"
                        iconPosition="end"
                        icon={<FontAwesomeIcon icon={'fa-solid fa-arrow-right-from-bracket'} />}
                        disabled={disabled || module?.status !== 'available'}
                        onClick={() => { navigate(module.path) }}
                        size="small"
                        className={openModuleButtonPresentation.className}
                        style={openModuleButtonPresentation.style}
                    >
                        {t('open_module', 'Mở phân hệ')}
                    </Button>
                </Flex>
                
            </div>
        </Card>
    )
}

export default ModuleCard;